<template>
    <div>
        <router-link :to="target">
            <button class="job-link-button secondary" :disabled="matchedView">
                {{ matchedView ? 'Job Already Loaded' : 'Load Existing Job' }}
            </button>
        </router-link>

        <HintBox v-if="mismatchedView" type="error" @click.native="$router.push(target)">
            The loaded view does not correspond to the task in this pane.
        </HintBox>
    </div>
</template>
<script setup>
import HintBox from '@/components/shared/hint-box.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'

const props = defineProps({
    companyId: {
        type: Number,
        required: true,
    },
    executiveId: {
        type: Number,
        required: true,
    },
})

const route = useRoute()

const matchedView = computed(() => {
    return (
        route.name === 'manage-executive-jobs-edit' &&
        route.params.executiveId == props.executiveId &&
        route.params.companyId == props.companyId
    )
})
const mismatchedView = computed(() => {
    return (
        route.name === 'manage-executive-jobs-edit' &&
        (route.params.executiveId != props.executiveId || route.params.companyId != props.companyId)
    )
})

const target = computed(() => {
    return {
        name: 'manage-executive-jobs-edit',
        params: { executiveId: props.executiveId, companyId: props.companyId },
    }
})
</script>
